// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/compound_services.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/compound_services.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_compound_services: GenFile = /*@__PURE__*/
  fileDesc("CjVtb2NoYWJ1Z2FwaXMvYWRhcHQvcGx1Z2lucy92MS9jb21wb3VuZF9zZXJ2aWNlcy5wcm90bxIdbW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEiVwoRR3JvdXBlZERlZmluaXRpb24SQgoIc2VydmljZXMYASADKAlCMLpILZIBKggBEDIYASIiciAQARhkMhpeW18kYS16QS1aXVtfJGEtekEtWjAtOV0qJCLJAQoPT25lT2ZEZWZpbml0aW9uEoUBCgdvcHRpb25zGAEgAygLMjsubW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEuT25lT2ZEZWZpbml0aW9uLk9wdGlvbnNFbnRyeUI3ukg0mgExCAEQMiIiciAQARhkMhpeW18kYS16QS1aXVtfJGEtekEtWjAtOV0qJCoHcgUQARj6ARouCgxPcHRpb25zRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4AWIGcHJvdG8z", [file_buf_validate_validate]);

/**
 * A grouped service definition that references multiple other flat service definitions.
 *
 * ## Architecture: Groups Reference Flat Definitions
 *
 * GroupedDefinition is itself a flat service definition at the Manifest.service_definitions level.
 * It references OTHER flat service definitions by name as a string array.
 *
 * ## Purpose
 *
 * Groups allow plugin authors to bundle related services together. For example:
 * - Production and sandbox environments for the same API
 * - Multiple related API keys
 * - Primary and backup authentication methods
 *
 * ## Example
 *
 * ```protobuf
 * // In Manifest.service_definitions
 * [
 *   { name: "stripe_prod", label: "Stripe Production", oauth2: {...} },
 *   { name: "stripe_sandbox", label: "Stripe Sandbox", oauth2: {...}, optional: true },
 *   {
 *     name: "stripe_envs",
 *     label: "Stripe Environments",
 *     group: {
 *       services: ["stripe_prod", "stripe_sandbox"]
 *     }
 *   }
 * ]
 *
 * // Referenced in system services list
 * system_services: ["stripe_envs"]
 *
 * // Plugin code accesses members with dot notation:
 * "stripe_envs.stripe_prod", "stripe_envs.stripe_sandbox"
 * ```
 *
 * @generated from message mochabugapis.adapt.plugins.v1.GroupedDefinition
 */
export type GroupedDefinition = Message<"mochabugapis.adapt.plugins.v1.GroupedDefinition"> & {
  /**
   * References to other flat service definitions that comprise this group
   *
   * @generated from field: repeated string services = 1;
   */
  services: string[];
};

/**
 * A grouped service definition that references multiple other flat service definitions.
 *
 * ## Architecture: Groups Reference Flat Definitions
 *
 * GroupedDefinition is itself a flat service definition at the Manifest.service_definitions level.
 * It references OTHER flat service definitions by name as a string array.
 *
 * ## Purpose
 *
 * Groups allow plugin authors to bundle related services together. For example:
 * - Production and sandbox environments for the same API
 * - Multiple related API keys
 * - Primary and backup authentication methods
 *
 * ## Example
 *
 * ```protobuf
 * // In Manifest.service_definitions
 * [
 *   { name: "stripe_prod", label: "Stripe Production", oauth2: {...} },
 *   { name: "stripe_sandbox", label: "Stripe Sandbox", oauth2: {...}, optional: true },
 *   {
 *     name: "stripe_envs",
 *     label: "Stripe Environments",
 *     group: {
 *       services: ["stripe_prod", "stripe_sandbox"]
 *     }
 *   }
 * ]
 *
 * // Referenced in system services list
 * system_services: ["stripe_envs"]
 *
 * // Plugin code accesses members with dot notation:
 * "stripe_envs.stripe_prod", "stripe_envs.stripe_sandbox"
 * ```
 *
 * @generated from message mochabugapis.adapt.plugins.v1.GroupedDefinition
 */
export type GroupedDefinitionJson = {
  /**
   * References to other flat service definitions that comprise this group
   *
   * @generated from field: repeated string services = 1;
   */
  services?: string[];
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.GroupedDefinition.
 * Use `create(GroupedDefinitionSchema)` to create a new message.
 */
export const GroupedDefinitionSchema: GenMessage<GroupedDefinition, {jsonType: GroupedDefinitionJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_compound_services, 0);

/**
 * A one-of service definition that allows users to choose from multiple flat service definitions.
 *
 * ## Architecture: One-Of References Flat Definitions
 *
 * OneOfDefinition is itself a flat service definition at the Manifest.service_definitions level.
 * It references OTHER flat service definitions by name.
 *
 * ## Purpose
 *
 * One-of definitions allow plugins to support multiple alternative implementations:
 * - Different payment providers (Stripe, PayPal, Square)
 * - Different authentication methods (OAuth2, API Key, mTLS)
 * - Different deployment environments
 *
 * Users choose ONE option during plugin installation/configuration.
 *
 * ## Example
 *
 * ```protobuf
 * // In Manifest.service_definitions
 * [
 *   { name: "stripe_oauth", label: "Stripe OAuth", oauth2: {...} },
 *   { name: "paypal_oauth", label: "PayPal OAuth", oauth2: {...} },
 *   { name: "square_oauth", label: "Square OAuth", oauth2: {...} },
 *   {
 *     name: "payment_provider",
 *     label: "Payment Provider",
 *     oneof: {
 *       options: {
 *         "stripe_oauth": "Stripe",
 *         "paypal_oauth": "PayPal",
 *         "square_oauth": "Square"
 *       }
 *     }
 *   }
 * ]
 *
 * // Referenced in system services list
 * system_services: ["payment_provider"]
 *
 * // Plugin code accesses using the service name:
 * "payment_provider" (regardless of which provider user chose)
 * ```
 *
 * @generated from message mochabugapis.adapt.plugins.v1.OneOfDefinition
 */
export type OneOfDefinition = Message<"mochabugapis.adapt.plugins.v1.OneOfDefinition"> & {
  /**
   * Map of service definition options users can choose from.
   *
   * Key: Service definition name (from Manifest.service_definitions)
   * Value: Human-friendly label shown to users during selection
   *
   * The map key must reference an existing ServiceDefinition.name.
   * The map value is displayed to users when choosing between options.
   *
   * ## Examples
   *
   * Basic options:
   *   options: {
   *     "stripe_oauth": "Stripe",
   *     "paypal_oauth": "PayPal"
   *   }
   *
   * Descriptive labels:
   *   options: {
   *     "stripe_oauth": "Stripe (recommended for production)",
   *     "paypal_oauth": "PayPal (simpler setup)"
   *   }
   *
   * @generated from field: map<string, string> options = 1;
   */
  options: { [key: string]: string };
};

/**
 * A one-of service definition that allows users to choose from multiple flat service definitions.
 *
 * ## Architecture: One-Of References Flat Definitions
 *
 * OneOfDefinition is itself a flat service definition at the Manifest.service_definitions level.
 * It references OTHER flat service definitions by name.
 *
 * ## Purpose
 *
 * One-of definitions allow plugins to support multiple alternative implementations:
 * - Different payment providers (Stripe, PayPal, Square)
 * - Different authentication methods (OAuth2, API Key, mTLS)
 * - Different deployment environments
 *
 * Users choose ONE option during plugin installation/configuration.
 *
 * ## Example
 *
 * ```protobuf
 * // In Manifest.service_definitions
 * [
 *   { name: "stripe_oauth", label: "Stripe OAuth", oauth2: {...} },
 *   { name: "paypal_oauth", label: "PayPal OAuth", oauth2: {...} },
 *   { name: "square_oauth", label: "Square OAuth", oauth2: {...} },
 *   {
 *     name: "payment_provider",
 *     label: "Payment Provider",
 *     oneof: {
 *       options: {
 *         "stripe_oauth": "Stripe",
 *         "paypal_oauth": "PayPal",
 *         "square_oauth": "Square"
 *       }
 *     }
 *   }
 * ]
 *
 * // Referenced in system services list
 * system_services: ["payment_provider"]
 *
 * // Plugin code accesses using the service name:
 * "payment_provider" (regardless of which provider user chose)
 * ```
 *
 * @generated from message mochabugapis.adapt.plugins.v1.OneOfDefinition
 */
export type OneOfDefinitionJson = {
  /**
   * Map of service definition options users can choose from.
   *
   * Key: Service definition name (from Manifest.service_definitions)
   * Value: Human-friendly label shown to users during selection
   *
   * The map key must reference an existing ServiceDefinition.name.
   * The map value is displayed to users when choosing between options.
   *
   * ## Examples
   *
   * Basic options:
   *   options: {
   *     "stripe_oauth": "Stripe",
   *     "paypal_oauth": "PayPal"
   *   }
   *
   * Descriptive labels:
   *   options: {
   *     "stripe_oauth": "Stripe (recommended for production)",
   *     "paypal_oauth": "PayPal (simpler setup)"
   *   }
   *
   * @generated from field: map<string, string> options = 1;
   */
  options?: { [key: string]: string };
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.OneOfDefinition.
 * Use `create(OneOfDefinitionSchema)` to create a new message.
 */
export const OneOfDefinitionSchema: GenMessage<OneOfDefinition, {jsonType: OneOfDefinitionJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_compound_services, 1);

